import React, {Component, PropTypes} from 'react';
import ClientSideCacheController from '../ClientSideCacheController';
import WarningList from './WarningList'
import DownloadAndSafety from './DownloadAndSafety'
import Radar from './Radar'
import VideoPlayer from '../FranklyVideoPlayerAdapter'
import Cannonicalize from '../Cannonicalize'
import OutsideScriptManager from '../OutsideScriptManager'


class WeatherTakeover extends Component {
  constructor(props) {
    super(props);
    this.debug = props.debug
    this.affiliate = props.affiliate;

    this.state = {

      banners: Cannonicalize.banner().banners,
      videoSources: [],
      streaming: false,
      watchExpanded: false,
      tab: 'default'

    }
  }

  componentWillMount() {

    if (typeof window !== 'object')
      return

  //  OutsideScriptManager.load('gpt');
    ClientSideCacheController.setAffiliate(this.props.affiliate)
    ClientSideCacheController.get('banner', {debug: this.debug}) //create Promise in advance

  }

  componentDidMount() {
    ClientSideCacheController.get('banner', {debug: this.debug}).then((banners) => {
      this.setState({
        banners: banners.banners.filter((b) => {
          return b.Content.toLowerCase().indexOf('weather') > -1
        })
      },()=>{
        if(window.innerWidth > 1470 && this.state.banners.length > 0) //don't bother if we aren't showing the takeover
          this.createLargeAd()
      })
    });



    window.gptadslots = window.gptadslots || [];
    window.googletag = window.googletag || {
      cmd: []
    };

  }

  createLargeAd = () =>{

    googletag.cmd.push(()=> {

      gptadslots.push(googletag.defineSlot('/43459271/loc-desktop/'+this.props.affiliate+ '/web/weather', [
        [300, 600]
      ], 'weather-takeover-large-ad').addService(googletag.pubads()));
      console.log('WeatherTakeover used %s','/43459271/loc-desktop/'+this.props.affiliate+ '/web/weather')
      googletag.pubads().enableSingleRequest();
      googletag.enableServices();
    });

    window.googletag.cmd.push(function() {
      googletag.display('weather-takeover-large-ad')
    }); //large header ad

  }

  playStream = (b, i) => {
    let banners = this.state.banners.map((banner, j) => {
      banner.playing = j === i
        ? true
        : false;
      return banner
    })
    this.setState({banners: banners})
    if (typeof b.EncoderUrls != 'object')
      return
    let newSource = []

    if (b.EncoderUrls[0].EncoderUrlTypeTitle == "Mobile")
      newSource = [
        {
          src: b.EncoderUrls[0].Url,
          type: 'application/x-mpegURL'
        }
      ]
    if (b.EncoderUrls[1].EncoderUrlTypeTitle == "Mobile")
      newSource = [
        {
          src: b.EncoderUrls[1].Url,
          type: 'application/x-mpegURL'
        }
      ]

    this.setState({videoSources: newSource, streaming: true})

  }

  bannerClass(b, i, a) {
    if (a.length <= 2) //all wide if two or less
      return 'full-width'
    let oddOrEven = 1
    if (a.length % 2 === 1) {
      oddOrEven = 0
      if (i === 0) //first one only wide
        return 'full-width'
    }
    if (i % 2 === oddOrEven) //if first one is wide, we offset the even ones instead
      return 'half-width-offset'
    else
      return 'half-width'
  }

  render() {

    if(this.props.show === false )
      return null
    if(this.debug === false && this.state.banners.length < 1)
      return null
    return (<div className='gnm-weather-takeover row'>
      <div className='col-xl-9 col-xs-12' style={{
          display: this.state.tab === 'default'
            ? 'block'
            : 'none'
        }}>
        <div className='row'>
          <div className='col-xl-8 col-lg-8 col-md-8 col-sm-7 col-xs-12' style={{
              display: this.state.tab === 'default'
                ? 'block'
                : 'none'
            }}>
            <h2 className='white text-center '>Severe Weather Coverage</h2>

            <div className='video-player' style={{
                display: this.state.streaming
                  ? 'none'
                  : 'block'
              }}>
              <a id='startGraphic' className="" href='#' onClick={(e) => {
                  console.log('playing first video by default')
                  this.playStream(this.state.banners[0], 0)
                }}>
                <div className='blackhover'/>
                <i className='fa fa-play-circle-o'/>
                <img src={this.props.affiliate == 'kotv'
                    ? `http://ftpcontent.worldnow.com/kotv/custom/wxtakeover/wx-takeover-tmeyer.jpg`
                    : `http://ftpcontent.worldnow.com/kotv/custom/wxtakeover/wx-takeover-dpayne.jpg`}/>
              </a>

            </div>
            <VideoPlayer sources={this.state.videoSources} autoPlay={true} contentClass='weather' closeCallback={() => {
                this.setState({streaming: false})
              }}/>
            <div className='live-feeds-container '>
              <h3>View Live Feeds</h3>
              {
                this.state.banners.map((b, i, a) => {
                  return (<div className={'live-feed ' + (
                      b.playing
                      ? 'selected '
                      : ' ') + this.bannerClass(b, i, a)} key={i} onClick={(e) => {
                      e.preventDefault();
                      this.playStream(b, i)
                    }}>
                    <a href="#">
                      <span>{b.Description}</span>
                      <span className='streaming'>Streaming</span>
                    </a>
                  </div>)
                })
              }
            </div>

          </div>
          <div className='col-xl-4 col-lg-4 col-md-4 col-sm-5 hidden-xs'>
            <div className='watcheswarnings'>
              <div className='watchheader'>
                <h6>Watches and Warnings</h6>
                <p>Get The Latest Info For Your County</p>
              </div>
              <div className='scroll-for-warnings'>
                <WarningList affiliate={this.props.affiliate} maxCount={3} debug={this.debug}/>
              </div>
              <Radar affiliate={this.props.affiliate}/>
              <DownloadAndSafety affiliate={this.props.affiliate}/>
            </div>
            <div className={'sliding-container ' + (
                this.state.watchExpanded
                ? 'expanded'
                : '')}>
              <h3>Watches and Warnings</h3>

              <button type='button' onClick={(e) => {
                  this.setState({
                    watchExpanded: !this.state.watchExpanded
                  })
                }}>
                <span>{
                    this.state.watchExpanded
                      ? 'Close'
                      : 'See All'
                  }</span>
                <i className={'fa ' + (
                    this.state.watchExpanded
                    ? 'fa-arrow-right'
                    : 'fa-arrow-left')}/>
              </button>
              <div className='scrollable-list-container'>
                <WarningList affiliate={this.props.affiliate}  debug={this.debug}/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='col-xl-3 visible-xl-block dark-background '>
        <div className='ad' id='weather-takeover-large-ad'>
        </div>
      </div>
      <div className='col-xs-12 hidden-sm hidden-md hidden-lg hidden-xl' style={{
          display: this.state.tab === 'alerts'
            ? 'block'
            : 'none'
        }}>
        <h3 className='text-center'>Alerts</h3>
        <h4 className='text-center'>Get The Latest Info For Your County</h4>
        <WarningList affiliate={this.props.affiliate}  debug={this.debug}/>
      </div>
      <div className='col-xs-12 hidden-sm hidden-md hidden-lg hidden-xl' style={{
          display: this.state.tab === 'radars'
            ? 'block'
            : 'none'
        }}>
        <Radar affiliate={this.props.affiliate}/>
      </div>
      <div className='col-xs-12 hidden-sm hidden-md hidden-lg hidden-xl'>
        <div className='row tab-buttons'>
          <div className={'col-xs-4  text-center ' + (
              this.state.tab === 'default'
              ? 'selected'
              : '')} onClick={(e) => {
              this.setState({tab: 'default'})
            }}>Live</div>
          <div className={'col-xs-4  text-center ' + (
              this.state.tab === 'alerts'
              ? 'selected'
              : '')} onClick={(e) => {
              this.setState({tab: 'alerts'})
            }}>Alerts</div>
          <div className={'col-xs-4  text-center ' + (
              this.state.tab === 'radars'
              ? 'selected'
              : '')} onClick={(e) => {
              this.setState({tab: 'radars'})
            }}>Radars</div>
        </div>

      </div>
    </div>);
  }
}

export default WeatherTakeover;



// WEBPACK FOOTER //
// ./app/components/custom/ssr/WeatherTakeover/index.js